/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Subscription information
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    tierCode: SubscriptionTierCodeEnum;
    /**
     * Billing period for the subscription
     * @type {string}
     * @memberof Subscription
     */
    billingPeriod: SubscriptionBillingPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    status: SubscriptionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    stripeCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    stripeSubscriptionId?: string | null;
    /**
     * Tier code that will be applied at renewsAt (period end)
     * @type {string}
     * @memberof Subscription
     */
    scheduledTierCode?: SubscriptionScheduledTierCodeEnum | null;
    /**
     * Start of current billing period from Stripe
     * @type {Date}
     * @memberof Subscription
     */
    currentPeriodStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    renewsAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    canceledAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    readonly updatedAt: Date;
}


/**
 * @export
 */
export const SubscriptionTierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type SubscriptionTierCodeEnum = typeof SubscriptionTierCodeEnum[keyof typeof SubscriptionTierCodeEnum];

/**
 * @export
 */
export const SubscriptionBillingPeriodEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type SubscriptionBillingPeriodEnum = typeof SubscriptionBillingPeriodEnum[keyof typeof SubscriptionBillingPeriodEnum];

/**
 * @export
 */
export const SubscriptionStatusEnum = {
    Active: 'active',
    PastDue: 'past_due',
    Canceled: 'canceled'
} as const;
export type SubscriptionStatusEnum = typeof SubscriptionStatusEnum[keyof typeof SubscriptionStatusEnum];

/**
 * @export
 */
export const SubscriptionScheduledTierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type SubscriptionScheduledTierCodeEnum = typeof SubscriptionScheduledTierCodeEnum[keyof typeof SubscriptionScheduledTierCodeEnum];


/**
 * Check if a given object implements the Subscription interface.
 */
export function instanceOfSubscription(value: object): value is Subscription {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    if (!('billingPeriod' in value) || value['billingPeriod'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('renewsAt' in value) || value['renewsAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SubscriptionFromJSON(json: any): Subscription {
    return SubscriptionFromJSONTyped(json, false);
}

export function SubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subscription {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'tierCode': json['tierCode'],
        'billingPeriod': json['billingPeriod'],
        'status': json['status'],
        'stripeCustomerId': json['stripeCustomerId'] == null ? undefined : json['stripeCustomerId'],
        'stripeSubscriptionId': json['stripeSubscriptionId'] == null ? undefined : json['stripeSubscriptionId'],
        'scheduledTierCode': json['scheduledTierCode'] == null ? undefined : json['scheduledTierCode'],
        'currentPeriodStart': json['currentPeriodStart'] == null ? undefined : (new Date(json['currentPeriodStart'])),
        'renewsAt': (new Date(json['renewsAt'])),
        'canceledAt': json['canceledAt'] == null ? undefined : (new Date(json['canceledAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SubscriptionToJSON(json: any): Subscription {
    return SubscriptionToJSONTyped(json, false);
}

export function SubscriptionToJSONTyped(value?: Omit<Subscription, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'tierCode': value['tierCode'],
        'billingPeriod': value['billingPeriod'],
        'status': value['status'],
        'stripeCustomerId': value['stripeCustomerId'],
        'stripeSubscriptionId': value['stripeSubscriptionId'],
        'scheduledTierCode': value['scheduledTierCode'],
        'currentPeriodStart': value['currentPeriodStart'] == null ? undefined : ((value['currentPeriodStart'] as any).toISOString()),
        'renewsAt': ((value['renewsAt']).toISOString()),
        'canceledAt': value['canceledAt'] == null ? undefined : ((value['canceledAt'] as any).toISOString()),
    };
}

